/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { PaymentMethodCard } from './PaymentMethodCard';
// @ts-ignore
import {
// @ts-ignore
    PaymentMethodCardFromJSON,
// @ts-ignore
    PaymentMethodCardFromJSONTyped,
// @ts-ignore
    PaymentMethodCardToJSON,
} from './PaymentMethodCard';

/**
 * 
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    id: string;
    /**
     * Provider customer identifier (e.g. Stripe cus_*)
     * @type {string}
     * @memberof PaymentMethod
     */
    customerId: string;
    /**
     * Provider payment method identifier (e.g. Stripe pm_*)
     * @type {string}
     * @memberof PaymentMethod
     */
    paymentMethodId: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    provider: string;
    /**
     * Whether the payment method can be deleted.
     * @type {boolean}
     * @memberof PaymentMethod
     */
    isDeletable: boolean;
    /**
     * 
     * @type {PaymentMethodCard}
     * @memberof PaymentMethod
     */
    card?: PaymentMethodCard;
}

/**
 * Check if a given object implements the PaymentMethod interface.
 */
// @ts-ignore
export function instanceOfPaymentMethod(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "customerId" in value;
    isInstance = isInstance && "paymentMethodId" in value;
    isInstance = isInstance && "provider" in value;
    isInstance = isInstance && "isDeletable" in value;

    return isInstance;
}

// @ts-ignore
export function PaymentMethodFromJSON(json: any): PaymentMethod {
    return PaymentMethodFromJSONTyped(json, false);
}

// @ts-ignore
export function PaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethod {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'customerId': json['customer_id'],
        'paymentMethodId': json['payment_method_id'],
        'provider': json['provider'],
        'isDeletable': json['is_deletable'],
        'card': !exists(json, 'card') ? undefined : PaymentMethodCardFromJSON(json['card']),
    };
}

// @ts-ignore
export function PaymentMethodToJSON(value?: PaymentMethod | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'customer_id': value.customerId,
        'payment_method_id': value.paymentMethodId,
        'provider': value.provider,
        'is_deletable': value.isDeletable,
        'card': PaymentMethodCardToJSON(value.card),
    };
}

